import script from "./hotel-room-filter.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel-room-filter.vue?vue&type=script&setup=true&lang=js"

import "./hotel-room-filter.vue?vue&type=style&index=0&id=20c442c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c442c8"]])

export default __exports__